module.exports = __webpack_public_path__ + "img/jasno&glasno.5a3af49c.jpg";